import React from "react";
import InsightCard from "../InsightCard/InsightCard";
import "../../styles/insightCards.css";

const imageStyle = {
  maxWidth: "100%",
  height: "auto",
  borderRadius: "6px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  cursor: "pointer",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
};

/**
 * Card with title and a clickable image (e.g. Revenue, Vessels, Landings).
 */
export default function ChartImageCard({ title, src, alt, onClick }) {
  const handleMouseEnter = (e) => {
    e.target.style.transform = "scale(1.02)";
    e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
  };
  const handleMouseLeave = (e) => {
    e.target.style.transform = "scale(1)";
    e.target.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
  };

  return (
    <InsightCard title={title}>
      <div>
        <img
          src={src}
          alt={alt}
          onClick={onClick}
          style={imageStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </div>
    </InsightCard>
  );
}
